/*
 * @Author: EdwardYoung
 * @Date: 2017-07-29 19:42:00
 * @Last Modified by: EdwardYoung
 * @Last Modified time: 2017-09-18 20:17:12
 */
/**
 * 根据当前商品handleId下单
 * @param {*当前商品handleid} handle
 */

async function nowBuy (skuId) {
  try {
    // const commodityId = await getCommodityId(handle)
    const item = {
      variant_id: skuId,
      quantity: 1,
      is_check: true
    }
    //  删除单个商品
    await removeSingleCommodity({
      variant_id: item.variant_id
    })
    //  取消所有选中商品
    await cancellAllSelectedCommodity()
    //  将商品加入购物车
    await addCart(item)
    //  修改商品数量
    await modifyQuantityOfCommodity({
      variant_id: item.variant_id,
      quantity: 1
    })
  } catch (err) {
    window.alert(err)
  }
}

//  获取商品id
// async function getCommodityId (handle) {
//   return new Promise((resolve, reject) => {
//     (function (yhsd) {
//       return yhsd.ready(function (sdk) {
//         return sdk
//           .product
//           .get(handle, function (inf) {
//             resolve(inf.res.product.variants[0].id)
//           })
//       })
//     })(window.yhsd, handle)
//   })
// }

//  根据商品id将商品加入购物车
async function addCart (item) {
  return new Promise((resolve, reject) => {
    (function (yhsd, item) {
      return yhsd.ready(function (sdk) {
        return sdk
          .cart
          .add(item, function (inf) {
            if (inf.code && inf.code !== 200) {
              reject('出错了请重新下单！')
            }
            // console.log('根据商品id将商品加入购物车', item)
            resolve()
          })
      })
    })(window.yhsd, item)
  })
}

//  取消所有选中商品
async function cancellAllSelectedCommodity () {
  return new Promise((resolve, reject) => {
    (function (yhsd) {
      return yhsd.ready(function (sdk) {
        return sdk
          .cart
          .unCheckAll(function () {
            // console.log('取消所有选中商品', sdk)
            resolve()
          })
      })
    })(window.yhsd)
  })
}

//  选中单个商品
// async function selectSingleCommodity (item) {
//   return new Promise((resolve, reject) => {
//     (function (yhsd, item) {
//       return yhsd.ready(function (sdk) {
//         return sdk
//           .cart
//           .checkOne(item, function () {
//             console.log('选中单个商品', item)
//             resolve()
//           })
//       })
//     })(window.yhsd, item)
//   })
// }

//  删除单个商品
async function removeSingleCommodity (item) {
  return new Promise((resolve, reject) => {
    (function (yhsd, item) {
      return yhsd.ready(function (sdk) {
        return sdk
          .cart
          .removeOne(item, function () {
            // console.log('删除单个商品', item)
            resolve()
          })
      })
    })(window.yhsd, item)
  })
}

//  修改商品数量
async function modifyQuantityOfCommodity (item) {
  return new Promise((resolve, reject) => {
    (function (yhsd, item) {
      return yhsd.ready(function (sdk) {
        return sdk
          .cart
          .quantity(item, function (inf) {
            if (inf.code && inf.code !== 200) {
              reject('出错了请重新下单！')
            }
            // console.log('修改商品数量', item)
            resolve()
          })
      })
    })(window.yhsd, item)
  })
}

export {nowBuy}



// WEBPACK FOOTER //
// ./src/api/nowBuy.js